import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  constructor() {}

  public get title() {
    return 'Mount Street Group';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }

  public get version() {
    return '3.0.18'; // This can be dynamically set based on your build process
  }
}
